import React from "react";
import Form from "../../home/Apply/Form";
import Squiggle from "./Squiggle";
import { APPLY_ANCHOR_ID } from "./anchors";
import { ReactComponent as Feather } from "../../../../assets/landing/patria-feather.svg";
import {
  Wrapper,
  Feather as FeatherSlot,
  Inner,
  Eyebrow,
  Headline,
  Subhead,
  CardWrap,
  Sticker,
  Card,
  Stats,
} from "./Hero.styles";

const stats = [
  { label: "Approvals", value: "Seconds" },
  { label: "Deposits", value: "Minutes" },
  { label: "Built", value: "For you" },
];

/**
 * The shared DirectMailActionButton renders different copy as a bordered button,
 * so it is hidden on this page (see styles-instant-cash.ts) and the reference's
 * caption is rendered here instead. Same destination, same empty-value guard —
 * the shared component is left untouched for /landing and /landing-2.
 */
const directMailUrl = process.env.REACT_APP_DIRECT_MAIL_URL;

/** the reference labels these fields differently from the shared form defaults */
const FORM_PLACEHOLDERS = {
  requestedLoan: "Loan amount",
  reason: "What's it for?",
  // The reference reads "SSN (last 4)", but validate.js still requires all 9
  // digits — that label would send users straight into a validation error.
  // Restore it only once the underwriting change lands.
  ssn: "SSN",
  phoneNumber: "Phone",
  email: "Email",
};

const Hero = () => {
  return (
    <Wrapper className="section-lp-hero">
      <FeatherSlot className="feather-left" aria-hidden="true">
        <Feather />
      </FeatherSlot>
      <FeatherSlot className="feather-right" aria-hidden="true">
        <Feather />
      </FeatherSlot>

      <Inner>
        <Eyebrow>
          <span className="dot" />
          Approvals in seconds
        </Eyebrow>

        <Headline>
          <span className="line">
            <span className="accent">Instant</span> Cash
          </span>
          <span className="line">
            When{" "}
            <span className="marked">
              <span>You</span>
            </span>{" "}
            Need It
          </span>
        </Headline>

        <Subhead>
          Fast, secure loans up to <strong>$2,000</strong> to help you cover
          what{" "}
          <span className="underlined">
            matters most.
            <Squiggle />
          </span>
        </Subhead>

        <CardWrap id={APPLY_ANCHOR_ID}>
          <Sticker className="sticker-left">Up to $2,000</Sticker>
          <Sticker className="sticker-right">
            <span className="dot" />
            Same-day deposits
          </Sticker>

          <Card className="form-wrapper">
            <p className="card-eyebrow">Check your approval</p>
            <h2 className="card-heading">
              See what you qualify for in{" "}
              <span className="accent">30 seconds</span>.
            </h2>
            <p className="card-note">No hard credit pull. No obligation.</p>
            <div className="card-form">
              <Form
                applyButtonLabel="See if you qualify"
                placeholders={FORM_PLACEHOLDERS}
              />
              {directMailUrl ? (
                <p className="mail-note">
                  Pre-approved by mail?{" "}
                  <a href={directMailUrl} target="_blank" rel="noreferrer">
                    Click here
                  </a>
                </p>
              ) : null}
            </div>
          </Card>
        </CardWrap>

        <Stats>
          {stats.map(({ label, value }) => (
            <div className="stat" key={label}>
              <span className="stat-label">{label}</span>
              <span className="stat-value">{value}</span>
            </div>
          ))}
        </Stats>
      </Inner>
    </Wrapper>
  );
};

export default Hero;
